import { render, staticRenderFns } from "./FileVersions.vue?vue&type=template&id=a363a5da&scoped=true&"
import script from "./FileVersions.vue?vue&type=script&lang=js&"
export * from "./FileVersions.vue?vue&type=script&lang=js&"
import style0 from "./FileVersions.vue?vue&type=style&index=0&id=a363a5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a363a5da",
  null
  
)

export default component.exports